var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRhoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#CC1E46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.816 9.24a11.174 11.174 0 015.753-2.2c.212-.043.442.091.435.325.02.56.006 1.12.006 1.68.014.174-.078.4-.278.405-1.846.204-3.6.958-5.124 2-.144.081-.112.268-.1.404.106.982.034 1.971.063 2.956 4.974.014 9.95-.002 14.926.008.237-.02.487.115.468.38.025 1.675.005 3.35.01 5.024.004.91-.19 1.852-.741 2.596-.87 1.169-2.4 1.87-3.854 1.612-1.03-.154-1.92-.793-2.544-1.604a11.207 11.207 0 01-5.844 2.215c-.215.003-.376-.208-.343-.414.007-.586-.012-1.174.01-1.76.05-.31.432-.25.659-.301 1.744-.272 3.412-1.003 4.836-2.04a37.333 37.333 0 01-.077-3.269c-4.992-.032-9.986-.002-14.978-.016-.22.025-.432-.14-.411-.373-.004-1.763-.003-3.527.002-5.29.01-.922.301-1.854.912-2.557.805-.916 2.019-1.501 3.251-1.429 1.18.047 2.263.718 2.963 1.648zM6.7 11.882c-.002 1.033-.003 2.067.002 3.102 1.234-.001 2.466.017 3.699-.01.002-1.008.015-2.015-.006-3.023-.019-.966-.892-1.82-1.862-1.8-.947-.039-1.81.79-1.833 1.73zm15.709 5.29c-.01.982-.002 1.965-.006 2.947-.006.393.113.777.34 1.097.474.677 1.418.973 2.19.674.713-.264 1.184-1.01 1.176-1.76 0-.986.005-1.97-.004-2.956-1.232-.01-2.464-.005-3.696-.003z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhoc);
export default __webpack_public_path__ + "static/media/rhoc.fdfd655ec0a1aa52f4b67cf117237593.svg";
export { ForwardRef as ReactComponent };